import type { SVGProps } from "react";
export const DiscoverTune = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M13.25 8.75V7.25H16.25V3.25H17.75V7.25H20.75V8.75H13.25ZM16.25 20.75V11.25H17.75V20.75H16.25ZM6.25 20.75V16.75H3.25V15.25H10.75V16.75H7.75V20.75H6.25ZM6.25 12.75V3.25H7.75V12.75H6.25Z"
			fill="currentColor"
		/>
	</svg>
);
